import { Component, computed, inject, input } from '@angular/core';
import type { OrderPaymentFormValues } from '@innogy/become-a-customer/state';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import { ibanConverter } from '@innogy/utils-deprecated';

import { OrderFulfillmentStepComponent } from '../order-fulfillment-step.component';

@Component({
  selector: 'wl-order-fulfillment-payment[progressiveFormState]',
  templateUrl: './order-fulfillment-payment.component.html',
  styleUrls: [],
})
export class OrderFulfillmentPaymentComponent extends OrderFulfillmentStepComponent<OrderPaymentFormValues> {
  public readonly _ibanConverter = ibanConverter;

  readonly deviceInfo = inject(MediaObserverService).deviceInfo;

  readonly labelsShownAboveFields = input(false);

  override readonly progressiveFormCardContent = computed(() => ({
    title: this.orderContent().paymentCardTitle.value ?? '',
    subtitle: this.orderContent().paymentCardSubtitle,
    submitButtonText: this.orderContent().paymentCardSubmitButton,
    stepNumber: this.stepNumber(),
  }));
}
